const stats = [
  { value: '94%', label: 'Response Rate', desc: 'Every inbound lead handled within 60 seconds' },
  { value: '3.2x', label: 'Average ROI', desc: 'Revenue increase across client deployments' },
  { value: '24/7', label: 'System Coverage', desc: 'Operational infrastructure that never sleeps' },
];

export default function WhySection() {
  return (
    <section id="why" className="bg-[#F5F5F0] py-28 md:py-36">
      <div className="max-w-[1360px] mx-auto px-8 md:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="w-full h-[540px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/113e1cda451ffaf1be9960796b511b6d.jpg"
                alt="AlphaOps AI performance metrics"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-6 bg-[#0A0A0A] rounded-xl p-5 shadow-xl">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-2 h-2 rounded-full bg-[#38C6F5] animate-pulse"></div>
                <span className="text-[#707070] text-xs uppercase tracking-widest">Live System</span>
              </div>
              <p className="text-white text-2xl font-light">+47 leads</p>
              <p className="text-[#707070] text-xs mt-1">captured this week</p>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-[#0A0A0A]"></span>
              <span className="text-[#0A0A0A] text-xs uppercase tracking-[3px]">Why AlphaOps AI</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-extralight text-[#0A0A0A] leading-tight mb-6">
              Businesses lose revenue in the{' '}
              <span className="font-semibold">gaps between inquiry and action.</span>
            </h2>
            <p className="text-[#555555] text-base leading-relaxed mb-4">
              We close those gaps. Our systems ensure that every call, form submission, and message is handled instantly and intelligently.
            </p>
            <p className="text-[#555555] text-base leading-relaxed mb-12">
              The result is faster response times, higher conversion rates, and stronger operational control — without increasing your headcount or overhead.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-12">
              {stats.map((stat) => (
                <div key={stat.label} className="border-t border-[#0A0A0A]/10 pt-5">
                  <div className="text-3xl font-light text-[#0A0A0A] mb-1">{stat.value}</div>
                  <div className="text-[#0A0A0A] text-xs font-semibold uppercase tracking-widest mb-2">{stat.label}</div>
                  <div className="text-[#888888] text-xs leading-relaxed">{stat.desc}</div>
                </div>
              ))}
            </div>

            <button
              onClick={() => {
                const el = document.getElementById('cta');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-[#0A0A0A] text-white text-sm font-medium px-8 py-4 rounded-full hover:bg-[#38C6F5] hover:text-black transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2 w-fit"
            >
              See How It Works
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
